const InlineImageLoadEventName = 'InlineImageLoad';
export { InlineImageLoadEventName };
